import { render, staticRenderFns } from "./ExtraEdit.vue?vue&type=template&id=519c9af7&scoped=true&"
import script from "./ExtraEdit.vue?vue&type=script&lang=js&"
export * from "./ExtraEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExtraEdit.vue?vue&type=style&index=0&id=519c9af7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519c9af7",
  null
  
)

export default component.exports